/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-20 15:42:39
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, change } from 'redux-form';
import { FormLayout, Popover } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderColorPicker2 } from 'src/components/views/common/forms/render-color-picker-2';
import {
  FILTER_OPTION_DISPLAY_TYPES_REVIEW_RATINGS,
  FILTER_OPTION_SELECT_TYPES
} from 'src/constants/filter-tree';

type Props = WithI18nProps;

class ReviewRatings extends Component<Props, State> {
  state = {
    hexColor: '#FFD117',
    activeColorPicker: false
  };

  componentDidMount() {
    const { reviewRatingsStarColor } = this.props;

    // Calculate hex color
    const { hex: hexColor } = reviewRatingsStarColor;
    this.setState({ hexColor });
  }

  render() {
    const { i18n } = this.props;
    const displayTypes = FILTER_OPTION_DISPLAY_TYPES_REVIEW_RATINGS.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const optionSelect = FILTER_OPTION_SELECT_TYPES.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const { displayType } = this.props;
    const { activeColorPicker, hexColor } = this.state;

    const activator = (
      <div className="colorPickerBox">
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <label className="Polaris-Label__Text" style={{ display: 'inline-flex' }}>
              {i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_GeneralTab_ReviewRatings_Activator'
              )}
            </label>
          </div>
        </div>
        <div className="Polaris-TextField">
          <input
            type="text"
            aria-labelledby="TextField36Label"
            aria-invalid="false"
            className="Polaris-TextField__Input"
            value={hexColor}
            onClick={this.handleOpenColorPicker}
            onChange={this.onInputColorValue}
          />
          <div className="Polaris-TextField__Backdrop"></div>
          <div
            className="Polaris-ResourceList__Badge selectedColor"
            style={{ backgroundColor: hexColor }}
            onClick={this.handleOpenColorPicker}></div>
        </div>
      </div>
    );

    return (
      <FormLayout>
        <Field
          name="reviewRatingsDisplayType"
          component={RenderSelect}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionDisplay_Label'
          )}
          options={displayTypes}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionDisplay_Tooltip'
          )}
        />

        <div className="reviewRatings-subtext">
          {displayType === 'seleted_ratings_and_above'
            ? i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_ReviewRatings_SubText1')
            : i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_ReviewRatings_SubText2')}
        </div>

        {displayType === 'selected_ratings_only' && (
          <Field
            name="reviewRatingsOptionSelect"
            component={RenderSelect}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Label')}
            options={optionSelect}
            tooltip={i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Tooltip')}
          />
        )}

        {/* Open color picker */}
        <Popover
          active={activeColorPicker}
          activator={activator}
          onClose={this.handleOpenColorPicker}
          preferredAlignment="left">
          <Field
            name="reviewRatingsStarColor"
            component={RenderColorPicker2}
            color={hexColor}
            onChange={this.handleChangeColor}
          />
        </Popover>
      </FormLayout>
    );
  }

  handleOpenColorPicker = () => {
    this.setState(({ activeColorPicker }) => ({
      activeColorPicker: !activeColorPicker
    }));
  };

  handleChangeColor = starColor => {
    const { hex: hexColor } = starColor;

    this.setState({ hexColor });
  };

  onInputColorValue = e => {
    const hexColor = e.target.value;

    // Convert hex to HSV color
    try {
      const { updateField } = this.props;

      this.setState({ hexColor });

      // update color on redux-form
      updateField('reviewRatingsStarColor', { hex: hexColor });

      return;
    } catch (error) {}

    this.setState({ hexColor });
  };
}

const mapStateToProps = (state, props) => {
  const formFilterOptionValues = getFormValues('OptionModalForm')(state);

  return {
    optionType: _.get(formFilterOptionValues, 'optionType', ''),
    displayType: _.get(formFilterOptionValues, 'reviewRatingsDisplayType', ''),
    reviewRatingsStarColor: _.get(formFilterOptionValues, 'reviewRatingsStarColor', {
      hex: '#FFD117'
    })
  };
};

const mapDispatchToProps = dispatch => ({
  updateField: (field, data) => dispatch(change('OptionModalForm', field, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(ReviewRatings));
